import api from '@/utils/api';

/**
 * Login user require {email}
 * @param {object} forgotPasswordData - The login data
 * @property {string} forgotPasswordData.email - The email of the user
 * @returns {Promise}
 */
const forgotPasswordApi = (forgotPasswordData) =>
  api.post('auth/forgot-password', forgotPasswordData);

export default forgotPasswordApi;
